import { IUser } from 'src/context/global/types';
import axios from 'src/services/axios';

import { handleApiResponse } from './utils';

const servicePath = ``;

// Note: Importantly, no export endpoints here
// All API call in service

const endpoints = {
  me: {
    url: `${servicePath}/auth-me`,
    method: 'GET',
  },
  login: {
    url: `${servicePath}/auth-login`,
    method: 'POST',
  },
  register: {
    url: `${servicePath}/auth-register`,
    method: 'POST',
  },
  changePassword: {
    url: `${servicePath}/change-password`,
    method: 'POST',
  },
  getUsers: {
    url: `${servicePath}/users-list`,
    method: 'GET',
  },
  updateUser: {
    url: `${servicePath}/users-update`,
    method: 'POST',
  },
};

interface IAuthLogin {
  email: string;
  password: string;
}

interface IAuthResponse {
  message: string;
  user: IUser;
  session_token: string;
  status: number;
}

interface IAuthRegister {
  name: string;
  email: string;
  password: string;
}

interface IAuthRegisterResponse {
  message: string;
  user: IUser;
  status: number;
}

interface IAuthChangePassword {
  current_password: string;
  new_password: string;
}

interface IAuthChangePasswordResponse {
  message: string;
  status: number;
}

interface IGetUsersQuery {
  userId?: string;
  search?: string;
  page?: number;
  limit?: number;
}

interface IAuthMeResponse {
  message: string;
  user: IUser;
  status: number;
}

interface IUpdateUser {
  name: string;
}

interface IUpdateUserResponse {
  message: string;
  user: IUser;
  status: number;
}

export class AuthServiceClass {
  private _client = axios;

  public async getCurrentUser(): Promise<IAuthMeResponse> {
    const res = await this._client.request({
      url: endpoints.me.url,
      method: endpoints.me.method,
    });

    return handleApiResponse<IAuthMeResponse>(res);
  }

  public async login(data: IAuthLogin): Promise<IAuthResponse> {
    const res = await this._client.request({
      url: endpoints.login.url,
      method: endpoints.login.method,
      data,
    });

    return handleApiResponse<IAuthResponse>(res);
  }

  public async register(data: IAuthRegister): Promise<IAuthRegisterResponse> {
    const res = await this._client.request({
      url: endpoints.register.url,
      method: endpoints.register.method,
      data,
    });

    return handleApiResponse<IAuthRegisterResponse>(res);
  }

  public async changePassword(
    data: IAuthChangePassword,
  ): Promise<IAuthChangePasswordResponse> {
    const res = await this._client.request({
      url: endpoints.changePassword.url,
      method: endpoints.changePassword.method,
      data,
    });

    return handleApiResponse<IAuthChangePasswordResponse>(res);
  }

  public async getUsers(params: IGetUsersQuery): Promise<IUser[]> {
    const res = await this._client.request({
      url: endpoints.getUsers.url,
      method: endpoints.getUsers.method,
      params,
    });

    return handleApiResponse<IUser[]>(res);
  }

  public async updateUser(data: IUpdateUser): Promise<IUpdateUserResponse> {
    const res = await this._client.request({
      url: endpoints.updateUser.url,
      method: endpoints.updateUser.method,
      data,
    });

    return handleApiResponse<IUpdateUserResponse>(res);
  }
}

export const authService = new AuthServiceClass();
